import { temAcesso } from '@/shared/auth/temAcesso'

const Parametros = () => import('./Parametros.vue')
// const JobDetalhar = () => import('./JobDetalhar.vue')
// const FornecedorDadosCadastrais = () => import('./../fornecedor/dadoscadastrais/DadosCadastraisDetalhar.vue')
// const FornecedorPagamentos = () => import('./../fornecedor/pagamentos/Pagamentos.vue')
// const FornecedorDirfs = () => import('./../fornecedor/dirfs/Dirfs.vue')
// const FornecedorContratos = () => import('./../fornecedor/contratos/Contratos.vue')
// const FornecedorCertidoes = () => import('./../fornecedor/certidoes/Certidoes.vue')

export default {
    path: 'parametros',
    name: 'Parametros',
    component: Parametros,
    beforeEnter: (to, from, next) => {
        if (temAcesso('ADMIN-PARAMETROS-00')) {
            next()
        }
    }
    // ,
    // children: [
    //     {
    //         path: ':jobId',
    //         name: 'Jobs_Detalhar',
    //         component: JobDetalhar,
    //         beforeEnter: (to, from, next) => {
    //             if (temAcesso('ADMIN-JOBS-00')) {
    //                 next()
    //             }
    //         }
    //     }
    // ]
}
